import vSelect from 'vue-select'
// eslint-disable-next-line import/extensions
import { register } from 'swiper/element/bundle'
import { Form as VForm } from 'vee-validate'

export default function registerOtherComponents(app) {
  register() // register Swiper elements globally (web components)

  app.component('VSelect', vSelect)
  app.component('VForm', VForm)
}
